import {Component, forwardRef} from "@angular/core";
import {SelectOptionsComponent} from "../../../framework/entity/select/options/select-options.component";
import {TranslateService} from "@ngx-translate/core";
import {ReasonCodeData} from "../reason-code.data";

@Component({
    selector: "wbo-reason-code-type-select-options",
    templateUrl: "./reason-code-type-select-options.component.html",
    providers: [{
        provide: SelectOptionsComponent,
        useExisting: forwardRef(() => ReasonCodeTypeSelectOptionsComponent),
        multi: true
    }]
})
export class ReasonCodeTypeSelectOptionsComponent extends SelectOptionsComponent {
    ReasonCodeData = ReasonCodeData;

    constructor(translateService: TranslateService) {
        super(translateService);
    }
}
